import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/common/SEOHead';

const section = {
  maxWidth: 800,
  margin: '0 auto',
  padding: '32px 20px',
};

const AboutPage = () => (
  <div className="page-container" style={{ padding: '20px 16px 60px' }}>
    <SEOHead
      title="About"
      description="The Orbital Ledger is a free, community-driven companion app for Star Citizen. Built by citizens, for citizens."
      path="/about"
    />
    <div style={section}>
      <h1 style={{
        fontFamily: "'Orbitron', sans-serif",
        color: '#00D1D1',
        fontSize: '2rem',
        marginBottom: 8,
      }}>
        About The Orbital Ledger
      </h1>
      <p style={{ color: '#8a8fa8', fontSize: '0.9rem', marginBottom: 32 }}>
        Built by citizens, for citizens.
      </p>

      <h2 style={{ color: '#E6E6E6', fontSize: '1.2rem', marginBottom: 12 }}>What is The Orbital Ledger?</h2>
      <p style={{ color: '#b8bcc8', lineHeight: 1.7, marginBottom: 24 }}>
        The Orbital Ledger (TOL) is a free, community-driven companion app for Star Citizen.
        We provide tools that help players track their inventory, plan profitable trade routes,
        monitor commodity prices in real-time, manage organizations, and connect with other
        citizens through our marketplace and social features.
      </p>

      <h2 style={{ color: '#E6E6E6', fontSize: '1.2rem', marginBottom: 12 }}>Our Mission</h2>
      <p style={{ color: '#b8bcc8', lineHeight: 1.7, marginBottom: 24 }}>
        Star Citizen is a massive, complex universe. Whether you're a solo trader running cargo
        between Hurston and ArcCorp, or leading a 50-person org on fleet operations, you need
        data and tools to make smart decisions. TOL exists to give every citizen — from new
        players to veteran fleet commanders — the information edge they need to succeed.
      </p>

      <h2 style={{ color: '#E6E6E6', fontSize: '1.2rem', marginBottom: 12 }}>Key Features</h2>
      <ul style={{ color: '#b8bcc8', lineHeight: 1.8, paddingLeft: 20, marginBottom: 24 }}>
        <li>Real-time commodity price tracking with community-submitted data</li>
        <li>Interactive trade route planner with profit calculations</li>
        <li>Personal inventory, wallet, and ship hangar management</li>
        <li>Equipment database with 1,700+ items across all categories</li>
        <li>Full organization suite: cargo, fleet, events, DKP, analytics</li>
        <li>Player-to-player marketplace and trading hub</li>
        <li>Ship matrix with detailed specifications</li>
        <li>Location database covering systems, planets, and stations</li>
      </ul>

      <h2 style={{ color: '#E6E6E6', fontSize: '1.2rem', marginBottom: 12 }}>Community First</h2>
      <p style={{ color: '#b8bcc8', lineHeight: 1.7, marginBottom: 24 }}>
        TOL is powered by its community. Commodity prices, item locations, and equipment data
        are submitted by real players sharing their discoveries. Every price submission helps
        someone else make a better trade. Every location report helps a new player find what
        they need. Together, we build the most comprehensive Star Citizen data resource available.
      </p>

      <h2 style={{ color: '#E6E6E6', fontSize: '1.2rem', marginBottom: 12 }}>Free & Premium</h2>
      <p style={{ color: '#b8bcc8', lineHeight: 1.7, marginBottom: 24 }}>
        Core features like commodity prices, the equipment database, ship specs, and trade
        route planning are free for everyone. Premium subscriptions unlock advanced tools
        like unlimited inventory tracking, goal setting, org creation, and more. Check out
        our <Link to="/purchase" style={{ color: '#00D1D1' }}>subscription plans</Link> for details.
      </p>

      <div style={{
        background: 'rgba(0, 209, 209, 0.08)',
        border: '1px solid rgba(0, 209, 209, 0.2)',
        borderRadius: 8,
        padding: '20px 24px',
        marginTop: 32,
      }}>
        <p style={{ color: '#8a8fa8', fontSize: '0.85rem', lineHeight: 1.6, margin: 0 }}>
          <strong style={{ color: '#E6E6E6' }}>Disclaimer:</strong> The Orbital Ledger is an independent
          community project and is not affiliated with, endorsed by, or sponsored by Cloud Imperium
          Games Corporation or Roberts Space Industries. Star Citizen is a registered trademark of
          Cloud Imperium Games Corporation.
        </p>
      </div>

      <div style={{ textAlign: 'center', marginTop: 40 }}>
        <p style={{ color: '#8a8fa8', marginBottom: 16 }}>
          Questions? Feedback? We'd love to hear from you.
        </p>
        <a
          href="mailto:support@theorbitalledger.com"
          style={{
            color: '#00D1D1',
            fontSize: '1rem',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          support@theorbitalledger.com
        </a>
      </div>
    </div>
  </div>
);

export default AboutPage;
